import type { DesktopWidget } from 'shared/api/containerApi'
import { SaveWidgetRequest } from 'shared/api/containerApi/requests'
import { WidgetConfiguration } from 'shared/api/containerApi/requests/getWidgets/getWidgets.types'
import { PersistedWidgetSpec } from 'shared/types/widgets'

export const transformWidgetsForSave = (
  widgets: PersistedWidgetSpec[],
  existingRows: DesktopWidget[] = []
): SaveWidgetRequest[] => {
  const existingById = new Map(existingRows.map(row => [row.id, row]))
  return widgets.map(item => {
    const existing = existingById.get(item.id)
    return {
      id: item.id,
      widget_key: String(item.widgetKey),
      configuration: {
        ...(existing?.configuration ?? {}),
        ...(item.config ?? {})
      } as WidgetConfiguration,
      size: item.size,
      display_order: item.displayOrder,
      is_collapsed: item.isCollapsed ?? false
    }
  })
}
